// extracted by mini-css-extract-plugin
module.exports = {"cardDetailsCheckbox":"DonationModal_cardDetailsCheckbox__AkQyk","terms":"DonationModal_terms__A57l0"};